GP.GPMod('ContentHome',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;
        },
        // Used to track if there's an image in the queue
        image_input_status: false,
        currently_fetching: false,
        grid_size: 0,
        first_load: false,
        max_columns: 2 ,
        current_column: 1,
    };
    var content_data = [];
    var content_collection = null;
    let columns = [];
    let collection_columns = [];

    // Public vars
    this.first_load = false;

    var gui = {
        init: function() {
            this.$content_text_input       = $('#content-text-input');
            this.$post_char_count          = $('#post-char-count');
            this.$trending_region          = $('#trending-region');
            this.$home_content_region      = $('#home-content-region');
            this.$page_loader_wrap         = $('#page-loader-wrap');
        }
    };

    var apis = {

    };

    var handlers = {
        show_content_result: function() {
            // if we can't find the trending-region id in the DOM, it's all for not
            if ($('#trending-region').length) {
                var trending_region_manager = new Marionette.RegionManager();
                let column_width = parseInt(100 / data.max_columns);
                let trending_region = document.querySelector("#trending-region");
                let max_columns_arr = [];
                // create new regions for each column needed
                // and append to template.
                for (let i = 1; i <= data.max_columns; i++) {

                    let column_name = `trending-region-col${i}`;

                    // create column regions if doesn't exist
                    if (!document.querySelectorAll(`#${column_name}`).length) {
                        max_columns_arr[i] = document.createElement('div');
                        max_columns_arr[i].id = column_name;
                        max_columns_arr[i].classList.add('trending-column', `column-width-${column_width}`);
                        trending_region.appendChild(max_columns_arr[i]);
                    }
                }

                let trending_view = null;

                for (i = 1; i < collection_columns.length; i++) {
                    let trending_column_list = new self.app.views.CompositeView({
                        collection: collection_columns[i],
                        sort: false
                    });
                    let column_name = `col${i}`;
                    trending_view = trending_region_manager.addRegions({
                        [column_name]: `#trending-region-col${i}`
                    });
                    trending_view[column_name].show(trending_column_list);
                }

                data.from_popstate = false;
            }
        },
    };

    var events = {
        init: function() {
             vent.on(self.moduleName+":init_home_content", events.init_home_content);
             vent.on(self.moduleName+":update_like_count", events.update_like_count);
             vent.on(self.moduleName+":update_comment_count", events.update_comment_count);
             vent.on(self.moduleName+":add_post", events.add_post);
             vent.on(self.moduleName+":hide_spinner", events.hide_spinner);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();

            // Character counter on post input.
            // gui.$content_text_input.on('keyup', function() {
            //     GP.Util.count_chars(gui.$content_text_input, gui.$post_char_count);
            // });
        },
        init_home_content: function(home_content) {
            events.setup_binds();

            if (home_content === undefined) {
                return;
            }

            data.grid_size = $('.grid-sizer').width();
            self.first_load = true;

            if (!_.isEmpty(home_content)) {
                events.show_spinner();

                // split feed_content into new columns
                events.create_collections(home_content.content);

                content_collection = new self.app.collections.Content();
                content_collection.add(home_content.content);

                if (MoshPit.get_size() == 'mobile') {
                    content_collection.reset(content_collection.first(4));
                }

                handlers.show_content_result();
            }
        },
        create_collections: function(content_data) {
            events.divide_content(content_data);

            // create new collections for each column
            for (i = 1; i < columns.length; i++) {
                collection_columns[i] = new self.app.collections.ContentTrending();
                collection_columns[i].add(columns[i]);
            }
        },
        divide_content: function(content_data) {
            columns = [];
            data.current_column = 1;

            for (i = 0; i < content_data.length; i++) {
                if (!Array.isArray(columns[data.current_column])) {
                    columns[data.current_column] = [];
                }

                columns[data.current_column].push(content_data[i]);

                if (data.current_column == data.max_columns) {
                    // set to 1st column if already at last column
                    data.current_column = 1;
                } else {
                    data.current_column++;
                }
            }
        },
        update_feed: function(json, reset) {
            setTimeout(function() {
                data.currently_fetching = false;
            }, 500);

            if (typeof(reset) !== 'undefined' && reset) {
                content_collection.reset();
                content_collection = new self.app.collections.Content();

                events.create_collections(json.content);
                content_collection = new self.app.collections.ContentTrending();
                handlers.show_content_result();
            } else {
                content_collection.add(json.content);
                events.divide_content(json.content);
                for (i = 1; i < columns.length; i++) {
                    collection_columns[i].add(columns[i]);
                }
            }

            // Update next page number
            if (typeof(json.next_page) !== 'undefined') {
                data.next_page = json.next_page;
            }

            gui.$btn_more_feed.removeClass('btn-loading');

            // Hide load more button
            if (json.show_load_more) {
                gui.$btn_more_feed_wrap.addClass('shown');
            } else {
                gui.$btn_more_feed_wrap.removeClass('shown');
            }
        },
        update_like_count: function(model) {
            var like_data = model;
            var feed_model = content_collection.find(function(model){
                return model.get('content_id') == like_data.get('content_id');
            });
            if (feed_model) {
                feed_model.set('is_liked', like_data.get('is_liked'));
                feed_model.set('like_count', like_data.get('like_count'));
            }
        },
        update_comment_count: function(model) {
            var comment_data = model;
            var feed_model = content_collection.find(function(model){
                return model.get('content_id') == comment_data.get('content_id');
            });
            if (feed_model) {
                feed_model.set('comment_count', comment_data.get('comment_count'));
            }
        },
        add_post: function(json) {
            // Here we add the users post to the top of trending page.
            // It's faked so if the user refreshes they most likely will not see their post
            // because sphinx hasn't indexed it yet.
            if (!_.isEmpty(json)) {
                // Add post to first model
                content_collection.unshift(json);

                // Add extra needed user info
                var post_model = content_collection.first();
                post_model.set('gender', (GP.sdata.my_user.gender == 'MAN') ? 'M' : 'F');
                post_model.set('pic', GP.sdata.my_user.pic);

                var temp_json = content_collection.toJSON();
                content_collection.reset();
                content_collection = new self.app.collections.Content();

                // Delay showing results so masonry renders new post in proper order.
                setTimeout(function() {
                    content_collection.add(temp_json);
                    handlers.show_content_result();
                }, 200);
            }
        },
        show_spinner: function() {
            if (gui.$page_loader_wrap) {
                gui.$page_loader_wrap.addClass('shown');
            }
        },
        hide_spinner: function() {
            if (gui.$page_loader_wrap) {
                gui.$page_loader_wrap.removeClass('shown');
            }
        }
    };

    this.addInitializer(function(){
        data.init();
        events.init();
    });
});
